import { combineReducers } from 'redux';
import { generators as projectsGenerators } from 'stores/projects';
import { generators as organizationsGenerators } from 'stores/organizations';
import {
  generators,
  getKeyByPostedComment,
  getKeyByPostedCommentSnippet,
  getKeyByPostedReview,
  getKeyByPullRequest,
} from './generators';

export const store = combineReducers({
  entries: projectsGenerators.pullRequests.pages.mapIndirect({
    store: organizationsGenerators.pullRequests.pages.mapIndirect({
      store: generators.entries.store(),
      getKeyByEntry: getKeyByPullRequest,
    }),
    getKeyByEntry: getKeyByPullRequest,
  }),
  refresh: generators.refresh.store(),
  toggleReview: generators.toggleReview.store(),
  postedComments: generators.postedComments.store(),
  postedCommentsEntries: generators.postedComments.mapIndirect({
    store: generators.postedCommentsEntries.store(),
    getKeyByEntry: getKeyByPostedComment,
  }),
  postedCommentSnippets: generators.postedCommentSnippets.store(),
  postedCommentSnippetsEntries: generators.postedCommentSnippets.mapIndirect({
    store: generators.postedCommentSnippetsEntries.store(),
    getKeyByEntry: getKeyByPostedCommentSnippet,
  }),
  postedReviews: generators.postedReviews.store(),
  postedReviewsEntries: generators.postedReviews.mapIndirect({
    store: generators.postedReviewsEntries.store(),
    getKeyByEntry: getKeyByPostedReview,
  }),
});
